import { Card, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { WorkoutPlan } from "../../../../service/model/workout.model";
import theme from "../../../../app/app-theme";

interface WorkoutPlanProps {
    workoutPlan?: WorkoutPlan;
}

const WorkoutPlanMemberView = ({ workoutPlan }: WorkoutPlanProps) => {

    return (
        <>
            {workoutPlan ? (
                <>
                    {workoutPlan.workoutDays.map((day, index) => (
                        <Grid size={{ xs: 12, md: 6}} sx={{ display: "flex", flexDirection: "column" }} key={index}>
                            <Card key={index} style={{ marginTop: "12px", padding: 12, backgroundColor: theme.palette.primary.contrastText, overflowY: "auto", height: "100%" }}>
                                <Typography variant="h6" sx={{ fontWeight: "bold", justifySelf: "center" }}>{day.name}</Typography>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Exercise</TableCell>
                                                <TableCell sx={{textAlign: "center"}}>Sets</TableCell>
                                                <TableCell sx={{textAlign: "center"}}>Reps</TableCell>
                                                <TableCell sx={{textAlign: "center"}}>Weight (kg)</TableCell>
                                                <TableCell sx={{textAlign: "center"}}>Duration (min)</TableCell>
                                                {/* <TableCell>Rest (sec)</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {day.exercises.map((exercise, index) => (
                                                <TableRow key={index}>
                                                    <TableCell >{exercise.exercise?.name}</TableCell>
                                                    <TableCell sx={{textAlign: "center"}}>{exercise.sets}</TableCell>
                                                    <TableCell sx={{textAlign: "center"}}>{exercise.reps}</TableCell>
                                                    <TableCell sx={{textAlign: "center"}}>{exercise.targetWeight}</TableCell>
                                                    <TableCell sx={{textAlign: "center"}}>{exercise.targetDuration}</TableCell>
                                                    {/* <TableCell>{exercise.restSeconds}</TableCell> */}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Grid>
                    ))}
                </>
            ) : (
                <p>No workout plan available for today.</p>
            )}
        </>
    );
}

export default WorkoutPlanMemberView;